<template>
  <el-header class="header-container">
    <el-row
      type="flex"
      class="wrap-row"
    >
      <el-col
        class="wrap-col"
        :xs="24"
        :sm="24"
        :md="14"
        :lg="14"
        :xl="14"
      >
        <div class="header-logo">
          <img
            class="hidden-md-and-up logo-image"
            src="/img/ostay-logo-simple-100x100.png"
            style="width: 36px; height: 36px;"
          />
          <img
            class="hidden-sm-and-down logo-image"
            src="/img/ostay-logo-385x100.png"
            style="width: 130px; height: 36px;"
          />

          <!-- <span class="header-label">
            <label v-if="activeIndex == '1'">{{$t('nav.idUpload')}}</label>
            <label v-else-if="activeIndex == '2'">{{$t('nav.pay')}}</label>
          </span> -->
        </div>

        <div class="header-label">
          <label v-if="activeIndex == '1'">{{$t('nav.idUpload')}}</label>
          <label v-else-if="activeIndex == '2'">{{$t('nav.pay')}}</label>
        </div>

        <div class="header-user">
          <el-tag class="customer-name">{{$store.state.userInfo.name}}</el-tag>
          <!-- <el-tag>Guest</el-tag> -->
        </div>

        <div class="header-lang">
          <el-dropdown @command="langToggle">
            <span class="el-dropdown-link">
              {{$t('lang.desc')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="ja">日本語</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      activeIndex: '1',
    }
  },
  methods: {
    langToggle (command) {
      this.$cookie.setLang(command)
      this.$i18n.locale = command
    },
  },
  created () {
    // 根据路由里面的字段，判断当前页是上传证件照页面还是stripe支付页面
    const baseUrl = window.location.hash
    if (baseUrl.indexOf('identification') > -1) {
      this.activeIndex = '1'
    }
    if (baseUrl.indexOf('payment') > -1) {
      this.activeIndex = '2'
    }
  },
}
</script>

<style scoped lang="scss">
.header-container {
  background: white;
  box-shadow: 0px 3px 6px rgba(108, 110, 130, 0.14);
  opacity: 1;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .wrap-row {
    height: 100%;
    // padding: 0 20px;
    .wrap-col {
      display: flex;
      margin: 0px auto;
      align-items: center;

      .header-logo {
        height: 100%;
        display: flex;
        align-items: center;
      }

      .header-label {
        margin-left: 20px;
      }

      .header-user {
        flex: 1;
        text-align: right;
        .customer-name {
          max-width: 150px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .header-lang {
        margin-left: auto;
        padding-left: 12px;
      }
    }
  }
}
</style>
